import React, { Component } from 'react';
import TopHeader from '../distributorHome/header';
import "../css/support.css";
// import SupportRemoteRequest from '../views/SupportRemoteAccess';



class RemoteAccessWindow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            timer: null,
            port: null,
            client_id: null,
            showTimeBar: true,
            timeBarPos: { x: null, y: null },
            draggingTimeBar: false,
            dragOffset: { x: 0, y: 0 }
        }
        this.timeBarHideThreshold = 56
    }

    handleTimeBarMouseDown = (e) => {
        if (e.target.tagName === 'BUTTON' || e.target.closest('button')) return
        const { timeBarPos } = this.state
        const rect = e.currentTarget.getBoundingClientRect()
        const x = timeBarPos.x != null ? timeBarPos.x : rect.left
        const y = timeBarPos.y != null ? timeBarPos.y : rect.top
        this.setState({
            draggingTimeBar: true,
            dragOffset: { x: e.clientX - x, y: e.clientY - y }
        })
    }

    handleTimeBarDragMove = (e) => {
        if (!this.state.draggingTimeBar) return
        const { dragOffset } = this.state
        const barW = 200
        const barH = 48
        const x = Math.max(0, Math.min(window.innerWidth - barW, e.clientX - dragOffset.x))
        const y = Math.max(0, Math.min(window.innerHeight - barH, e.clientY - dragOffset.y))
        this.setState({ timeBarPos: { x, y } })
    }

    handleTimeBarDragEnd = () => {
        this.setState({ draggingTimeBar: false })
    }

    handleFullScreenMouseMove = (e) => {
        const show = e.clientY < this.timeBarHideThreshold
        this.setState(prev => (prev.showTimeBar === show ? prev : { ...prev, showTimeBar: show }))
    }


    validateRemoteAccessToken(token, projectId) {
        const TokenValue = 'Token ' + localStorage.getItem("auth"); // Assuming token is stored in localStorage
        // If no existing token or the token is expired, proceed with token generation
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];

        const payload = {
            token
        };

        fetch('/we/validate-remote-access-token/', {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
               // alert(data.client_id + "   " + this.state.client_id)
                if (data.status === "valid" && data.client_id === this.state.client_id) {
                    
                    localStorage.setItem(`remoteTokenExpiresAt_${projectId}`, data.expires_at)
                    // alert(data.expiry)
                    const expiresAt = new Date(data.expires_at);
                    const currentTime = new Date();

                    // If the token has not expired, show an alert
                    if (currentTime < expiresAt) {
                        const remainingTime = Math.floor((expiresAt - currentTime) / 1000); // Remaining time in seconds
                        this.setState({ timer: remainingTime })
                    }
                   // console.log(data)
                    this.startCountdown();
                    // alert("redirecting to access")

                } else {

                    alert("remote access time expired. request access again")
                    localStorage.removeItem(`remoteToken_${projectId}`);
                    localStorage.removeItem(`remoteTokenExpiresAt_${projectId}`);
                }
            })
            .catch(error => {
                console.error('Error generating remote access token:', error);
                // alert("Error validating remote access token. Please try again.")
            });
    }
    componentDidMount() {
        const projectId = window.location.pathname.split('/')[3];
        const search = new URLSearchParams(window.location.search)
        const remote_access_port = search.get("port")
        const token = search.get("token")
        this.setState({ port: remote_access_port })
        this.setState({ client_id: projectId })
        // this.setState({ token: token })
        // Check if a token already exists for this project_id in localStorage
        // const existingToken = localStorage.getItem(`remoteToken_${projectId}`);
        // const existingTokenExpiresAt = localStorage.getItem(`remoteTokenExpiresAt_${projectId}`);

        // if (existingToken && existingTokenExpiresAt) {
        // Parse the expiration time and compare it with the current time
        // const expiresAt = new Date(existingTokenExpiresAt);
        // const currentTime = new Date();

        // If the token has not expired, show an alert
        // if (currentTime < expiresAt) {
        // const remainingTime = Math.floor((expiresAt - currentTime) / 1000); // Remaining time in seconds
        // this.setState({ timer: remainingTime })

        this.validateRemoteAccessToken(token, projectId, remote_access_port)

        this._boundMouseMove = this.handleFullScreenMouseMove.bind(this)
        this._boundDragMove = this.handleTimeBarDragMove.bind(this)
        this._boundDragEnd = this.handleTimeBarDragEnd.bind(this)

        // Hide sidebar when remote access iframe page loads
        setTimeout(() => {
            const sidebar = document.querySelector('.sidenav');
            if (sidebar) {
                // use setAttribute to try to override inline styles
                sidebar.setAttribute('style', 'display: none !important');
                console.log('Sidebar hidden (distributor)');
            } else {
                console.log('Sidebar element not found (distributor)');
            }
        }, 100);

        // } else {
        //     alert("time expired")
        // }
        // } else {
        //     alert("time expired")
        // }
        // this.validateRemoteAccessToken()
    }

    startCountdown() {
        this.timerInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.timer > 0) {
                    return { timer: prevState.timer - 1 };
                } else {
                    clearInterval(this.timerInterval);
                    alert("Time expired");
                    return { timer: 0 };
                }
            });
        }, 1000);
    }

    formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        // Format with leading zeroes
        const format = (num) => (num < 10 ? `0${num}` : num);

        return `${format(hours)}:${format(minutes)}:${format(secs)}`;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.timer === 0) {
            window.location.reload()
        }
        const enteredFullScreen = this.state.timer > 0 && (prevState.timer === null || prevState.timer <= 0)
        if (enteredFullScreen && this._boundMouseMove) {
            window.addEventListener('mousemove', this._boundMouseMove)
        }
        if (this.state.draggingTimeBar && !prevState.draggingTimeBar) {
            window.addEventListener('mousemove', this._boundDragMove)
            window.addEventListener('mouseup', this._boundDragEnd)
        }
        if (!this.state.draggingTimeBar && prevState.draggingTimeBar) {
            window.removeEventListener('mousemove', this._boundDragMove)
            window.removeEventListener('mouseup', this._boundDragEnd)
        }
    }

    componentWillUnmount() {
        // Restore sidebar visibility when leaving remote access page
        const sidebar = document.querySelector('.sidenav');
        if (sidebar) {
            sidebar.style.display = 'block';
            console.log('Sidebar shown (distributor)');
        }
        // clear any intervals if present
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        if (this._boundMouseMove) window.removeEventListener('mousemove', this._boundMouseMove)
        if (this._boundDragMove) window.removeEventListener('mousemove', this._boundDragMove)
        if (this._boundDragEnd) window.removeEventListener('mouseup', this._boundDragEnd)
    }
    render() {
        const { timer, port, client_id } = this.state;
        const iframeSrc = (port && port !== "null")
            ? `https://proxy${port}.okas.in`
            : (client_id ? `https://ds${client_id}.okas.one` : null);

        const isFullScreen = timer > 0 && iframeSrc;

        return (
            <div className="root remote-access-window" style={{ margin: 0, padding: 0, overflow: 'hidden', height: '100vh' }}>
                {!isFullScreen && <TopHeader history={this.props.history} />}
                {!isFullScreen && (
                    <div className="selfcontainer">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <h3>Remote Access</h3>
                            <div style={{ fontSize: "20px" }}>
                                {this.state.timer !== null ? (
                                    <p>Time Remaining: {this.formatTime(this.state.timer)}</p>
                                ) : (
                                    <p>Time Expired</p>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {isFullScreen && (
                    <>
                        <iframe
                            src={iframeSrc}
                            title="Remote Access"
                            frameBorder="0"
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100vh',
                                border: 'none',
                                display: 'block',
                                zIndex: 0
                            }}
                        />
                        <div
                            role="presentation"
                            onMouseDown={this.handleTimeBarMouseDown}
                            style={{
                                position: 'fixed',
                                ...(this.state.timeBarPos.x != null
                                    ? { left: this.state.timeBarPos.x, top: this.state.timeBarPos.y }
                                    : { right: 12, top: 12 }),
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                background: 'rgba(29, 43, 54, 0.9)',
                                color: '#fff',
                                padding: '10px 16px',
                                borderRadius: 8,
                                fontSize: 14,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                cursor: this.state.draggingTimeBar ? 'grabbing' : 'grab',
                                userSelect: 'none'
                            }}
                        >
                            <span>Time: {this.formatTime(timer)}</span>
                            <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); (this.props.history ? this.props.history.push('/support2') : (window.location.href = '/support2')); }}
                                style={{ background: 'none', border: 'none', color: '#fff', marginLeft: 4, textDecoration: 'underline', cursor: 'pointer', fontSize: 13 }}
                            >
                                Exit
                            </button>
                        </div>
                    </>
                )}
            </div>
        )
    }
}

export default RemoteAccessWindow;